<template>
  <div>
    <global-top-header />
    <div class="md:px-4 py-6 md:py-10">
      <div class="flex flex-col md:flex-row gap-1">
        <div class="w-full md:w-64 shrink-0">
          <HeroSidebar />
        </div>
        <div class="flex-1">
          <div class="mb-4">{{ $route.meta.title }}</div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroSidebar from "@/components/common/HeroSideBar.vue";

export default {
  components: {
    HeroSidebar,
  },
};
</script>
